import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["bound", "columns"];
import React from "react";
import styled from "styled-components";
import Grid from "../Grid";
import Box from "../Box";
import Text from "../Text";
import { useThemeDefaults } from "../utils";
export var Heading = useThemeDefaults(function (_ref) {
  var theme = _ref.theme;
  return {
    color: theme.boundedGrid.heading.color,
    textStyle: theme.boundedGrid.heading.textStyle
  };
}, Text);
export var Primary = useThemeDefaults(function (_ref2) {
  var theme = _ref2.theme;
  return {
    color: theme.boundedGrid.primary.color,
    textStyle: theme.boundedGrid.primary.textStyle,
    truncate: true
  };
}, Text);
export var Secondary = useThemeDefaults(function (_ref3) {
  var theme = _ref3.theme;
  return {
    color: theme.boundedGrid.secondary.color,
    textStyle: theme.boundedGrid.secondary.textStyle
  };
}, Text);
export var Item = styled(Box).withConfig({
  displayName: "BoundedGrid__Item",
  componentId: "sc-152s159-0"
})(["display:flex;flex-direction:column;align-items:baseline;justify-content:left;"]);
export var BoundedGrid = function BoundedGrid(_ref4) {
  var _ref4$bound = _ref4.bound,
      bound = _ref4$bound === void 0 ? 1 : _ref4$bound,
      _ref4$columns = _ref4.columns,
      columns = _ref4$columns === void 0 ? [2, 3, 6, 6] : _ref4$columns,
      props = _objectWithoutProperties(_ref4, _excluded);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, _extends({
    gridTemplateColumns: columns.map(function (n) {
      return "repeat(".concat(n, ", minmax(0, 1fr))");
    }),
    gridTemplateRows: columns.map(function (n) {
      return "repeat(".concat(Math.floor(bound / n), ", minmax(0, 1fr))");
    })
  }, props)));
};
BoundedGrid.Heading = Heading;
BoundedGrid.Primary = Primary;
BoundedGrid.Secondary = Secondary;
BoundedGrid.Item = Item;
export default BoundedGrid;